/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import { Chart } from 'react-google-charts';
import { getChartColors, getChartDataByValues , CHART_METRICS } from '../../../utils/charts';
import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from '../../../reducers';
import { loadByUtrId } from '../../../slice/utrvChartDataSlice';
import { UniversalTrackerPlain } from '../../../types/universalTracker';

interface UtrTableChartProps {
  universalTracker: UniversalTrackerPlain;
  /** @deprecated not used? */
  changeDirection: number;
}

export const UtrTableChart = ({ universalTracker }: UtrTableChartProps) => {
  const chartValues = useSelector((state: RootState) => state.utrvChartData.data);
  const chartValue = chartValues[universalTracker._id];
  const chartData = getChartDataByValues(chartValues[universalTracker._id]);
  const initiativeId = useSelector((state: RootState) => state.initiative.data?._id);
  const dispatch = useAppDispatch();

  React.useEffect(() => {
    if (!initiativeId) {
      return;
    }
    dispatch(loadByUtrId(initiativeId, universalTracker._id));
  }, [dispatch, initiativeId, universalTracker, chartValue]);

  if (!chartData || chartData.length === 0) {
    chartData.push(CHART_METRICS);
  }

  return (
    <Chart
      chartType='LineChart'
      data={chartData}
      options={{
        lineWidth: 2,
        colors: getChartColors(),
        chartArea: {
          left: 3,
          top: 3,
          bottom: 3,
          right: 3,
        },
        backgroundColor: '#f5f5f0',
        hAxis: {
          baselineColor: 'none',
          ticks: [],
        },
        interpolateNulls: true,
        vAxis: {
          baselineColor: 'transparent',
          ticks: [],
          minValue: 0,
        },
        series: {
          0: { type: 'line' },
          1: { type: 'line' },
        },
      }}
      width='131px'
      height='100%'
    />
  );
};
